var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _rect592, _rect593, _rect594, _rect595, _rect596, _rect597, _rect598, _rect599, _rect600, _rect601, _rect602, _rect603, _rect604, _rect605, _rect606, _rect607, _rect608, _rect609, _rect610, _rect611, _rect612, _rect613, _rect614, _rect615, _rect616, _rect617, _rect618, _rect619, _rect620, _rect621, _rect622, _rect623, _rect624, _rect625, _rect626, _rect627, _rect628, _rect629, _rect630, _rect631, _rect632, _rect633, _rect634, _rect635, _rect636, _rect637, _rect638, _rect639, _rect640, _rect641, _rect642, _rect643, _rect644, _rect645, _rect646, _rect647, _rect648, _rect649, _rect650, _rect651, _rect652, _rect653, _rect654, _rect655, _rect656, _rect657, _rect658, _rect659, _rect660, _rect661, _rect662, _rect663, _rect664, _rect665, _rect666, _rect667, _rect668, _rect669, _rect670, _rect671, _rect672, _rect673, _rect674, _rect675, _rect676, _rect677, _rect678, _rect679, _rect680, _rect681, _rect682, _rect683, _rect684, _rect685, _rect686, _rect687, _rect688, _rect689, _rect690, _rect691, _rect692, _rect693, _rect694, _rect695, _rect696, _rect697, _rect698, _rect699, _rect700, _rect701, _rect702, _rect703, _rect704, _rect705, _rect706, _rect707, _rect708, _rect709, _rect710, _rect711, _rect712, _rect713, _rect714, _rect715, _rect716, _rect717, _rect718, _rect719, _rect720, _rect721, _rect722, _rect723, _rect724, _rect725, _rect726, _rect727, _rect728, _rect729, _rect730, _rect731, _rect732, _rect733, _rect734, _rect735, _rect736, _rect737, _rect738, _rect739, _rect740, _rect741, _rect742, _rect743, _rect744, _rect745, _rect746, _rect747, _rect748, _rect749, _rect750, _rect751, _rect752, _rect753, _rect754, _rect755, _rect756, _rect757, _rect758, _rect759, _rect760, _rect761, _rect762, _rect763, _rect764, _rect765, _rect766, _rect767, _rect768, _rect769, _rect770, _rect771, _rect772, _rect773, _rect774, _rect775, _rect776, _rect777, _rect778, _rect779, _rect780, _rect781, _rect782, _rect783, _rect784, _rect785, _rect786, _rect787, _rect788, _rect789, _rect790, _rect791, _rect792, _rect793, _rect794, _rect795, _rect796, _rect797, _rect798, _rect799, _rect800, _rect801, _rect802, _rect803, _rect804, _rect805, _rect806, _rect807, _rect808, _rect809, _rect810, _rect811, _rect812, _rect813, _rect814, _rect815, _rect816, _rect817, _rect818, _rect819, _rect820, _rect821, _rect822, _rect823, _rect824, _rect825, _rect826, _rect827, _rect828, _rect829, _rect830, _rect831, _rect832, _rect833, _rect834, _rect835, _rect836, _rect837, _rect838, _rect839, _rect840, _rect841, _rect842, _rect843, _rect844, _rect845, _rect846, _rect847, _rect848, _rect849, _rect850, _rect851, _rect852, _rect853, _rect854, _rect855, _rect856, _rect857, _rect858, _rect859, _rect860, _rect861, _rect862, _rect863, _rect864, _rect865, _rect866, _rect867, _rect868, _rect869, _rect870, _rect871, _rect872, _rect873, _rect874, _rect875, _rect876, _rect877, _rect878, _rect879, _rect880, _rect881, _rect882, _rect883, _rect884, _rect885, _rect886, _rect887, _rect888, _rect889, _rect890, _rect891, _rect892, _rect893, _rect894, _rect895, _rect896, _rect897, _rect898, _rect899, _rect900, _rect901, _rect902, _rect903, _rect904, _rect905, _rect906, _rect907, _rect908, _rect909, _rect910, _rect911, _rect912, _rect913, _rect914, _rect915, _rect916, _rect917, _rect918, _rect919, _rect920, _rect921, _rect922, _rect923, _rect924, _rect925, _rect926, _rect927, _rect928, _rect929, _rect930, _rect931, _rect932, _rect933, _rect934, _rect935, _rect936, _rect937, _rect938, _rect939, _rect940, _rect941, _rect942, _rect943, _rect944, _rect945, _rect946, _rect947, _rect948, _rect949, _rect950, _rect951, _rect952, _rect953, _rect954, _rect955, _rect956, _rect957, _rect958, _rect959, _rect960, _rect961, _rect962, _rect963, _rect964, _rect965, _rect966, _rect967, _rect968, _rect969, _rect970, _rect971, _rect972, _rect973, _rect974, _rect975, _rect976, _rect977, _rect978, _rect979, _rect980, _rect981, _rect982, _rect983, _rect984, _rect985, _rect986, _rect987, _rect988, _rect989, _rect990, _rect991, _rect992, _rect993, _rect994, _rect995, _rect996, _rect997, _rect998, _rect999, _rect1000, _rect1001, _rect1002, _rect1003, _rect1004, _rect1005, _rect1006, _rect1007, _rect1008, _rect1009, _rect1010, _rect1011, _rect1012, _rect1013, _rect1014, _rect1015, _rect1016, _rect1017, _rect1018, _rect1019, _rect1020, _rect1021, _rect1022, _rect1023, _rect1024, _rect1025, _rect1026, _rect1027, _rect1028, _rect1029, _rect1030, _rect1031, _rect1032, _rect1033, _rect1034, _rect1035, _rect1036, _rect1037, _rect1038, _rect1039, _rect1040, _rect1041, _rect1042, _rect1043, _rect1044, _rect1045, _rect1046, _rect1047, _rect1048, _rect1049, _rect1050, _rect1051, _rect1052, _rect1053, _rect1054, _rect1055, _rect1056, _rect1057, _rect1058, _rect1059, _rect1060, _rect1061, _rect1062, _rect1063, _rect1064, _rect1065, _rect1066, _rect1067, _rect1068, _rect1069, _rect1070, _rect1071, _rect1072, _rect1073, _rect1074, _rect1075, _rect1076, _rect1077, _rect1078, _rect1079, _rect1080, _rect1081, _rect1082, _rect1083, _rect1084, _rect1085, _rect1086, _rect1087, _rect1088, _rect1089, _rect1090, _rect1091, _rect1092, _rect1093, _rect1094, _rect1095, _rect1096;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtPanda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 635,
    viewBox: "0 0 586 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 618.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 455.778)",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 48.8333)",
    fill: "black"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 586 146.5)",
    fill: "black"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 65.1111)",
    fill: "black"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 65.1111)",
    fill: "black"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 586 162.778)",
    fill: "black"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 586 211.611)",
    fill: "black"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 81.3889)",
    fill: "black"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 81.3889)",
    fill: "black"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 586 179.056)",
    fill: "black"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 586 227.889)",
    fill: "black"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 227.889)",
    fill: "black"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 293)",
    fill: "black"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 244.167)",
    fill: "black"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 309.278)",
    fill: "black"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 260.444)",
    fill: "black"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 325.556)",
    fill: "black"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 276.722)",
    fill: "black"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 341.833)",
    fill: "black"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 406.944)",
    fill: "black"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 358.111)",
    fill: "black"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 423.222)",
    fill: "black"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 472.056)",
    fill: "black"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 374.389)",
    fill: "black"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 439.5)",
    fill: "black"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 488.333)",
    fill: "black"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 390.667)",
    fill: "black"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 455.778)",
    fill: "black"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 504.611)",
    fill: "black"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 97.6667)",
    fill: "black"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 97.6667)",
    fill: "black"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 586 195.333)",
    fill: "black"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 113.944)",
    fill: "black"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 113.944)",
    fill: "black"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 130.222)",
    fill: "black"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 130.222)",
    fill: "black"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 130.222)",
    fill: "black"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 586,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 586 130.222)",
    fill: "black"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 16.2778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 212.12,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 212.12)",
    fill: "black"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 212.12,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 212.12)",
    fill: "black"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 212.12,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 212.12)",
    fill: "black"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2778,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5557,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 618.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 472.056)",
    fill: "black"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 276.722)",
    fill: "black"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 293)",
    fill: "black"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 406.944)",
    fill: "black"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 390.667)",
    fill: "black"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 390.667)",
    fill: "black"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 406.944)",
    fill: "black"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 244.167)",
    fill: "black"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 260.444)",
    fill: "black"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 374.389)",
    fill: "black"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 358.111)",
    fill: "black"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 358.111)",
    fill: "black"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 374.389)",
    fill: "black"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 227.889)",
    fill: "black"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 244.167)",
    fill: "black"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 358.111)",
    fill: "black"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 341.833)",
    fill: "black"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 341.833)",
    fill: "black"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 358.111)",
    fill: "black"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 211.611)",
    fill: "black"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 227.889)",
    fill: "black"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 341.833)",
    fill: "black"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 325.556)",
    fill: "black"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 325.556)",
    fill: "black"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 341.833)",
    fill: "black"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 195.333)",
    fill: "black"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 211.611)",
    fill: "black"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 325.556)",
    fill: "black"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 309.278)",
    fill: "black"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 309.278)",
    fill: "black"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 325.556)",
    fill: "black"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 260.444)",
    fill: "black"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 276.722)",
    fill: "black"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 390.667)",
    fill: "black"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 374.389)",
    fill: "black"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 374.389)",
    fill: "black"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 390.667)",
    fill: "black"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 293)",
    fill: "black"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 309.278)",
    fill: "black"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 423.222)",
    fill: "black"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 406.944)",
    fill: "black"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 423.222)",
    fill: "black"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 358.111)",
    fill: "black"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 423.222)",
    fill: "black"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 406.944)",
    fill: "black"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 390.667)",
    fill: "black"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 374.389)",
    fill: "black"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 406.944)",
    fill: "black"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 423.222)",
    fill: "black"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 358.111)",
    fill: "black"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 423.222)",
    fill: "black"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 406.944)",
    fill: "black"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 390.667)",
    fill: "black"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 374.389)",
    fill: "black"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 423.222)",
    fill: "black"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 618.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 488.333)",
    fill: "black"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 618.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 504.611)",
    fill: "black"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 618.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 520.889)",
    fill: "black"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 618.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 537.167)",
    fill: "black"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 504.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect592 || (_rect592 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 488.333,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect593 || (_rect593 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 472.056,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect594 || (_rect594 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect595 || (_rect595 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect596 || (_rect596 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect597 || (_rect597 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect598 || (_rect598 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect599 || (_rect599 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect600 || (_rect600 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect601 || (_rect601 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect602 || (_rect602 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect603 || (_rect603 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect604 || (_rect604 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect605 || (_rect605 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect606 || (_rect606 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect607 || (_rect607 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect608 || (_rect608 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect609 || (_rect609 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect610 || (_rect610 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect611 || (_rect611 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect612 || (_rect612 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect613 || (_rect613 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect614 || (_rect614 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect615 || (_rect615 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect616 || (_rect616 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect617 || (_rect617 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect618 || (_rect618 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect619 || (_rect619 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect620 || (_rect620 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect621 || (_rect621 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect622 || (_rect622 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect623 || (_rect623 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect624 || (_rect624 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect625 || (_rect625 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect626 || (_rect626 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect627 || (_rect627 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect628 || (_rect628 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect629 || (_rect629 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect630 || (_rect630 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect631 || (_rect631 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect632 || (_rect632 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect633 || (_rect633 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect634 || (_rect634 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect635 || (_rect635 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect636 || (_rect636 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 293)",
    fill: "white"
  })), _rect637 || (_rect637 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 211.611)",
    fill: "white"
  })), _rect638 || (_rect638 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 195.333)",
    fill: "white"
  })), _rect639 || (_rect639 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 195.333)",
    fill: "white"
  })), _rect640 || (_rect640 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 195.333)",
    fill: "white"
  })), _rect641 || (_rect641 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 179.056)",
    fill: "white"
  })), _rect642 || (_rect642 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 244.167)",
    fill: "white"
  })), _rect643 || (_rect643 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 179.056)",
    fill: "white"
  })), _rect644 || (_rect644 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 244.167)",
    fill: "white"
  })), _rect645 || (_rect645 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 211.611)",
    fill: "white"
  })), _rect646 || (_rect646 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 195.333)",
    fill: "white"
  })), _rect647 || (_rect647 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 130.222 195.333)",
    fill: "white"
  })), _rect648 || (_rect648 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 179.056)",
    fill: "white"
  })), _rect649 || (_rect649 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 162.778)",
    fill: "white"
  })), _rect650 || (_rect650 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 130.222)",
    fill: "white"
  })), _rect651 || (_rect651 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 113.944)",
    fill: "white"
  })), _rect652 || (_rect652 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 113.944)",
    fill: "white"
  })), _rect653 || (_rect653 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 130.222 113.944)",
    fill: "white"
  })), _rect654 || (_rect654 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 113.944)",
    fill: "white"
  })), _rect655 || (_rect655 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 97.6667)",
    fill: "white"
  })), _rect656 || (_rect656 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 97.6667)",
    fill: "white"
  })), _rect657 || (_rect657 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 81.3889)",
    fill: "white"
  })), _rect658 || (_rect658 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 81.3889)",
    fill: "white"
  })), _rect659 || (_rect659 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 48.8333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 48.8333)",
    fill: "white"
  })), _rect660 || (_rect660 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 32.5557)",
    fill: "white"
  })), _rect661 || (_rect661 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 32.5557)",
    fill: "white"
  })), _rect662 || (_rect662 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 32.5557)",
    fill: "white"
  })), _rect663 || (_rect663 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 32.5557)",
    fill: "white"
  })), _rect664 || (_rect664 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 32.5557,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 32.5557)",
    fill: "white"
  })), _rect665 || (_rect665 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 130.222 97.6667)",
    fill: "white"
  })), _rect666 || (_rect666 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 97.6667)",
    fill: "white"
  })), _rect667 || (_rect667 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 81.3889)",
    fill: "white"
  })), _rect668 || (_rect668 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 81.3889)",
    fill: "white"
  })), _rect669 || (_rect669 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 65.1111)",
    fill: "white"
  })), _rect670 || (_rect670 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect671 || (_rect671 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect672 || (_rect672 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 309.278)",
    fill: "white"
  })), _rect673 || (_rect673 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 227.889)",
    fill: "white"
  })), _rect674 || (_rect674 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 211.611)",
    fill: "white"
  })), _rect675 || (_rect675 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 211.611)",
    fill: "white"
  })), _rect676 || (_rect676 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 211.611)",
    fill: "white"
  })), _rect677 || (_rect677 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 195.333)",
    fill: "white"
  })), _rect678 || (_rect678 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 195.333)",
    fill: "white"
  })), _rect679 || (_rect679 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 227.889)",
    fill: "white"
  })), _rect680 || (_rect680 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 211.611)",
    fill: "white"
  })), _rect681 || (_rect681 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 130.222)",
    fill: "white"
  })), _rect682 || (_rect682 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 113.944)",
    fill: "white"
  })), _rect683 || (_rect683 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 113.944)",
    fill: "white"
  })), _rect684 || (_rect684 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 113.944)",
    fill: "white"
  })), _rect685 || (_rect685 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 97.6667)",
    fill: "white"
  })), _rect686 || (_rect686 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 97.6667)",
    fill: "white"
  })), _rect687 || (_rect687 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 195.333)",
    fill: "white"
  })), _rect688 || (_rect688 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 179.056)",
    fill: "white"
  })), _rect689 || (_rect689 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 146.5)",
    fill: "white"
  })), _rect690 || (_rect690 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 130.222)",
    fill: "white"
  })), _rect691 || (_rect691 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 130.222)",
    fill: "white"
  })), _rect692 || (_rect692 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 130.222 130.222)",
    fill: "white"
  })), _rect693 || (_rect693 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 130.222)",
    fill: "white"
  })), _rect694 || (_rect694 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 113.944)",
    fill: "white"
  })), _rect695 || (_rect695 = /*#__PURE__*/React.createElement("rect", {
    x: 179.056,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 179.056 113.944)",
    fill: "white"
  })), _rect696 || (_rect696 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 97.6667)",
    fill: "white"
  })), _rect697 || (_rect697 = /*#__PURE__*/React.createElement("rect", {
    x: 162.778,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 162.778 130.222)",
    fill: "white"
  })), _rect698 || (_rect698 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect699 || (_rect699 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect700 || (_rect700 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 325.556)",
    fill: "white"
  })), _rect701 || (_rect701 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 244.167)",
    fill: "white"
  })), _rect702 || (_rect702 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 227.889)",
    fill: "white"
  })), _rect703 || (_rect703 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 227.889)",
    fill: "white"
  })), _rect704 || (_rect704 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 244.167)",
    fill: "white"
  })), _rect705 || (_rect705 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 227.889)",
    fill: "white"
  })), _rect706 || (_rect706 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 146.5)",
    fill: "white"
  })), _rect707 || (_rect707 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 130.222)",
    fill: "white"
  })), _rect708 || (_rect708 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 130.222)",
    fill: "white"
  })), _rect709 || (_rect709 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 130.222)",
    fill: "white"
  })), _rect710 || (_rect710 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 113.944)",
    fill: "white"
  })), _rect711 || (_rect711 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 113.944)",
    fill: "white"
  })), _rect712 || (_rect712 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 211.611)",
    fill: "white"
  })), _rect713 || (_rect713 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 195.333)",
    fill: "white"
  })), _rect714 || (_rect714 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 162.778)",
    fill: "white"
  })), _rect715 || (_rect715 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 146.5)",
    fill: "white"
  })), _rect716 || (_rect716 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 146.5)",
    fill: "white"
  })), _rect717 || (_rect717 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 130.222 146.5)",
    fill: "white"
  })), _rect718 || (_rect718 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 146.5)",
    fill: "white"
  })), _rect719 || (_rect719 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 162.778)",
    fill: "white"
  })), _rect720 || (_rect720 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 130.222 162.778)",
    fill: "white"
  })), _rect721 || (_rect721 = /*#__PURE__*/React.createElement("rect", {
    x: 146.5,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 146.5 162.778)",
    fill: "white"
  })), _rect722 || (_rect722 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 179.056)",
    fill: "white"
  })), _rect723 || (_rect723 = /*#__PURE__*/React.createElement("rect", {
    x: 130.222,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 130.222 179.056)",
    fill: "white"
  })), _rect724 || (_rect724 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect725 || (_rect725 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 341.833)",
    fill: "white"
  })), _rect726 || (_rect726 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 260.444)",
    fill: "white"
  })), _rect727 || (_rect727 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 244.167)",
    fill: "white"
  })), _rect728 || (_rect728 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 244.167)",
    fill: "white"
  })), _rect729 || (_rect729 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 260.444)",
    fill: "white"
  })), _rect730 || (_rect730 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 276.722)",
    fill: "white"
  })), _rect731 || (_rect731 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 244.167)",
    fill: "white"
  })), _rect732 || (_rect732 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 162.778)",
    fill: "white"
  })), _rect733 || (_rect733 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 146.5)",
    fill: "white"
  })), _rect734 || (_rect734 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 146.5)",
    fill: "white"
  })), _rect735 || (_rect735 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 146.5)",
    fill: "white"
  })), _rect736 || (_rect736 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 130.222)",
    fill: "white"
  })), _rect737 || (_rect737 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 130.222)",
    fill: "white"
  })), _rect738 || (_rect738 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 227.889)",
    fill: "white"
  })), _rect739 || (_rect739 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 211.611)",
    fill: "white"
  })), _rect740 || (_rect740 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 179.056)",
    fill: "white"
  })), _rect741 || (_rect741 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 162.778)",
    fill: "white"
  })), _rect742 || (_rect742 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect743 || (_rect743 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 358.111)",
    fill: "white"
  })), _rect744 || (_rect744 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 276.722)",
    fill: "white"
  })), _rect745 || (_rect745 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 260.444)",
    fill: "white"
  })), _rect746 || (_rect746 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 260.444)",
    fill: "white"
  })), _rect747 || (_rect747 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 179.056)",
    fill: "white"
  })), _rect748 || (_rect748 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 162.778)",
    fill: "white"
  })), _rect749 || (_rect749 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 179.056)",
    fill: "white"
  })), _rect750 || (_rect750 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 179.056)",
    fill: "white"
  })), _rect751 || (_rect751 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 146.5)",
    fill: "white"
  })), _rect752 || (_rect752 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 113.944)",
    fill: "white"
  })), _rect753 || (_rect753 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 97.6667)",
    fill: "white"
  })), _rect754 || (_rect754 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 81.3889)",
    fill: "white"
  })), _rect755 || (_rect755 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 65.1111)",
    fill: "white"
  })), _rect756 || (_rect756 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 227.889)",
    fill: "white"
  })), _rect757 || (_rect757 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 162.778)",
    fill: "white"
  })), _rect758 || (_rect758 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 179.056)",
    fill: "white"
  })), _rect759 || (_rect759 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 179.056)",
    fill: "white"
  })), _rect760 || (_rect760 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 146.5)",
    fill: "white"
  })), _rect761 || (_rect761 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 113.944)",
    fill: "white"
  })), _rect762 || (_rect762 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 97.6667)",
    fill: "white"
  })), _rect763 || (_rect763 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 81.3889)",
    fill: "white"
  })), _rect764 || (_rect764 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 65.1111)",
    fill: "white"
  })), _rect765 || (_rect765 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 227.889)",
    fill: "white"
  })), _rect766 || (_rect766 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 162.778)",
    fill: "white"
  })), _rect767 || (_rect767 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 179.056)",
    fill: "white"
  })), _rect768 || (_rect768 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 179.056)",
    fill: "white"
  })), _rect769 || (_rect769 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 146.5)",
    fill: "white"
  })), _rect770 || (_rect770 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 113.944)",
    fill: "white"
  })), _rect771 || (_rect771 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 97.6667)",
    fill: "white"
  })), _rect772 || (_rect772 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 81.3889)",
    fill: "white"
  })), _rect773 || (_rect773 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 65.1111)",
    fill: "white"
  })), _rect774 || (_rect774 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 227.889)",
    fill: "white"
  })), _rect775 || (_rect775 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 146.5)",
    fill: "white"
  })), _rect776 || (_rect776 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 146.5)",
    fill: "white"
  })), _rect777 || (_rect777 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 179.056)",
    fill: "white"
  })), _rect778 || (_rect778 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 244.167)",
    fill: "white"
  })), _rect779 || (_rect779 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 227.889)",
    fill: "white"
  })), _rect780 || (_rect780 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 195.333)",
    fill: "white"
  })), _rect781 || (_rect781 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 179.056)",
    fill: "white"
  })), _rect782 || (_rect782 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect783 || (_rect783 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 374.389)",
    fill: "white"
  })), _rect784 || (_rect784 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 293)",
    fill: "white"
  })), _rect785 || (_rect785 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 276.722)",
    fill: "white"
  })), _rect786 || (_rect786 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 276.722)",
    fill: "white"
  })), _rect787 || (_rect787 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 276.722)",
    fill: "white"
  })), _rect788 || (_rect788 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 309.278)",
    fill: "white"
  })), _rect789 || (_rect789 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 309.278)",
    fill: "white"
  })), _rect790 || (_rect790 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 309.278)",
    fill: "white"
  })), _rect791 || (_rect791 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 309.278)",
    fill: "white"
  })), _rect792 || (_rect792 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 309.278)",
    fill: "white"
  })), _rect793 || (_rect793 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 293)",
    fill: "white"
  })), _rect794 || (_rect794 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 309.278)",
    fill: "white"
  })), _rect795 || (_rect795 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 293)",
    fill: "white"
  })), _rect796 || (_rect796 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 293)",
    fill: "white"
  })), _rect797 || (_rect797 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 293)",
    fill: "white"
  })), _rect798 || (_rect798 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 309.278)",
    fill: "white"
  })), _rect799 || (_rect799 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 308.26,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 308.26)",
    fill: "white"
  })), _rect800 || (_rect800 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 325.556)",
    fill: "white"
  })), _rect801 || (_rect801 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 324.538,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 324.538)",
    fill: "white"
  })), _rect802 || (_rect802 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 325.556)",
    fill: "white"
  })), _rect803 || (_rect803 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 325.556)",
    fill: "white"
  })), _rect804 || (_rect804 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 325.556)",
    fill: "white"
  })), _rect805 || (_rect805 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 341.833)",
    fill: "white"
  })), _rect806 || (_rect806 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 325.556)",
    fill: "white"
  })), _rect807 || (_rect807 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 341.833)",
    fill: "white"
  })), _rect808 || (_rect808 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 358.111)",
    fill: "white"
  })), _rect809 || (_rect809 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 358.111)",
    fill: "white"
  })), _rect810 || (_rect810 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 374.389)",
    fill: "white"
  })), _rect811 || (_rect811 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 325.556)",
    fill: "white"
  })), _rect812 || (_rect812 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 341.833)",
    fill: "white"
  })), _rect813 || (_rect813 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 325.556)",
    fill: "white"
  })), _rect814 || (_rect814 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 260.444)",
    fill: "white"
  })), _rect815 || (_rect815 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 260.444)",
    fill: "white"
  })), _rect816 || (_rect816 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 276.722)",
    fill: "white"
  })), _rect817 || (_rect817 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 293)",
    fill: "white"
  })), _rect818 || (_rect818 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 309.278)",
    fill: "white"
  })), _rect819 || (_rect819 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 325.556)",
    fill: "white"
  })), _rect820 || (_rect820 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 260.444)",
    fill: "white"
  })), _rect821 || (_rect821 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 276.722)",
    fill: "white"
  })), _rect822 || (_rect822 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 293)",
    fill: "white"
  })), _rect823 || (_rect823 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 309.278)",
    fill: "white"
  })), _rect824 || (_rect824 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 325.556)",
    fill: "white"
  })), _rect825 || (_rect825 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 276.722)",
    fill: "white"
  })), _rect826 || (_rect826 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 293)",
    fill: "white"
  })), _rect827 || (_rect827 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 309.278)",
    fill: "white"
  })), _rect828 || (_rect828 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 325.556)",
    fill: "white"
  })), _rect829 || (_rect829 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 341.833)",
    fill: "white"
  })), _rect830 || (_rect830 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 325.556)",
    fill: "white"
  })), _rect831 || (_rect831 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 260.444)",
    fill: "white"
  })), _rect832 || (_rect832 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 260.444)",
    fill: "white"
  })), _rect833 || (_rect833 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 276.722)",
    fill: "white"
  })), _rect834 || (_rect834 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 293)",
    fill: "white"
  })), _rect835 || (_rect835 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 309.278)",
    fill: "white"
  })), _rect836 || (_rect836 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 325.556)",
    fill: "white"
  })), _rect837 || (_rect837 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 276.722)",
    fill: "white"
  })), _rect838 || (_rect838 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 293)",
    fill: "white"
  })), _rect839 || (_rect839 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 309.278)",
    fill: "white"
  })), _rect840 || (_rect840 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 309.278)",
    fill: "white"
  })), _rect841 || (_rect841 = /*#__PURE__*/React.createElement("rect", {
    x: 113.944,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 113.944 276.722)",
    fill: "white"
  })), _rect842 || (_rect842 = /*#__PURE__*/React.createElement("rect", {
    x: 211.611,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 211.611 195.333)",
    fill: "white"
  })), _rect843 || (_rect843 = /*#__PURE__*/React.createElement("rect", {
    x: 227.889,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 227.889 179.056)",
    fill: "white"
  })), _rect844 || (_rect844 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 195.333)",
    fill: "white"
  })), _rect845 || (_rect845 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 195.333)",
    fill: "white"
  })), _rect846 || (_rect846 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 162.778)",
    fill: "white"
  })), _rect847 || (_rect847 = /*#__PURE__*/React.createElement("rect", {
    x: 309.278,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 309.278 130.222)",
    fill: "white"
  })), _rect848 || (_rect848 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 244.167)",
    fill: "white"
  })), _rect849 || (_rect849 = /*#__PURE__*/React.createElement("rect", {
    x: 244.167,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 244.167 179.056)",
    fill: "white"
  })), _rect850 || (_rect850 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 244.167)",
    fill: "white"
  })), _rect851 || (_rect851 = /*#__PURE__*/React.createElement("rect", {
    x: 260.444,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 260.444 179.056)",
    fill: "white"
  })), _rect852 || (_rect852 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 244.167)",
    fill: "white"
  })), _rect853 || (_rect853 = /*#__PURE__*/React.createElement("rect", {
    x: 276.722,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 276.722 162.778)",
    fill: "white"
  })), _rect854 || (_rect854 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 179.056)",
    fill: "white"
  })), _rect855 || (_rect855 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 179.056)",
    fill: "white"
  })), _rect856 || (_rect856 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 146.5)",
    fill: "white"
  })), _rect857 || (_rect857 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 113.944)",
    fill: "white"
  })), _rect858 || (_rect858 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 97.6667)",
    fill: "white"
  })), _rect859 || (_rect859 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 81.3889)",
    fill: "white"
  })), _rect860 || (_rect860 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 97.6667)",
    fill: "white"
  })), _rect861 || (_rect861 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 113.944)",
    fill: "white"
  })), _rect862 || (_rect862 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 130.222)",
    fill: "white"
  })), _rect863 || (_rect863 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 146.5)",
    fill: "white"
  })), _rect864 || (_rect864 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 162.778)",
    fill: "white"
  })), _rect865 || (_rect865 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 81.3889)",
    fill: "white"
  })), _rect866 || (_rect866 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 97.6667)",
    fill: "white"
  })), _rect867 || (_rect867 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 113.944)",
    fill: "white"
  })), _rect868 || (_rect868 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 130.222)",
    fill: "white"
  })), _rect869 || (_rect869 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 146.5)",
    fill: "white"
  })), _rect870 || (_rect870 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 162.778)",
    fill: "white"
  })), _rect871 || (_rect871 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 65.1111)",
    fill: "white"
  })), _rect872 || (_rect872 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 227.889)",
    fill: "white"
  })), _rect873 || (_rect873 = /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 293 162.778)",
    fill: "white"
  })), _rect874 || (_rect874 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 179.056)",
    fill: "white"
  })), _rect875 || (_rect875 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 179.056)",
    fill: "white"
  })), _rect876 || (_rect876 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 146.5)",
    fill: "white"
  })), _rect877 || (_rect877 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 113.944)",
    fill: "white"
  })), _rect878 || (_rect878 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 97.6667)",
    fill: "white"
  })), _rect879 || (_rect879 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 81.3889)",
    fill: "white"
  })), _rect880 || (_rect880 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 97.6667)",
    fill: "white"
  })), _rect881 || (_rect881 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 113.944)",
    fill: "white"
  })), _rect882 || (_rect882 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 130.222)",
    fill: "white"
  })), _rect883 || (_rect883 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 146.5)",
    fill: "white"
  })), _rect884 || (_rect884 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 162.778)",
    fill: "white"
  })), _rect885 || (_rect885 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 81.3889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 81.3889)",
    fill: "white"
  })), _rect886 || (_rect886 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 97.6667)",
    fill: "white"
  })), _rect887 || (_rect887 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 97.6667)",
    fill: "white"
  })), _rect888 || (_rect888 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 97.6667,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 97.6667)",
    fill: "white"
  })), _rect889 || (_rect889 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 113.944)",
    fill: "white"
  })), _rect890 || (_rect890 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 130.222)",
    fill: "white"
  })), _rect891 || (_rect891 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 113.944)",
    fill: "white"
  })), _rect892 || (_rect892 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 113.944)",
    fill: "white"
  })), _rect893 || (_rect893 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 113.944,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 113.944)",
    fill: "white"
  })), _rect894 || (_rect894 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 130.222)",
    fill: "white"
  })), _rect895 || (_rect895 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 146.5)",
    fill: "white"
  })), _rect896 || (_rect896 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 130.222)",
    fill: "white"
  })), _rect897 || (_rect897 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 130.222)",
    fill: "white"
  })), _rect898 || (_rect898 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 130.222)",
    fill: "white"
  })), _rect899 || (_rect899 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 146.5)",
    fill: "white"
  })), _rect900 || (_rect900 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 162.778)",
    fill: "white"
  })), _rect901 || (_rect901 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 146.5)",
    fill: "white"
  })), _rect902 || (_rect902 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 146.5)",
    fill: "white"
  })), _rect903 || (_rect903 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 146.5)",
    fill: "white"
  })), _rect904 || (_rect904 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 162.778)",
    fill: "white"
  })), _rect905 || (_rect905 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 179.056)",
    fill: "white"
  })), _rect906 || (_rect906 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 195.333)",
    fill: "white"
  })), _rect907 || (_rect907 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 179.056)",
    fill: "white"
  })), _rect908 || (_rect908 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 162.778)",
    fill: "white"
  })), _rect909 || (_rect909 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 162.778)",
    fill: "white"
  })), _rect910 || (_rect910 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 162.778)",
    fill: "white"
  })), _rect911 || (_rect911 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 179.056)",
    fill: "white"
  })), _rect912 || (_rect912 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 195.333)",
    fill: "white"
  })), _rect913 || (_rect913 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 211.611)",
    fill: "white"
  })), _rect914 || (_rect914 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 227.889)",
    fill: "white"
  })), _rect915 || (_rect915 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 227.889)",
    fill: "white"
  })), _rect916 || (_rect916 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 276.722)",
    fill: "white"
  })), _rect917 || (_rect917 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 276.722)",
    fill: "white"
  })), _rect918 || (_rect918 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 227.889)",
    fill: "white"
  })), _rect919 || (_rect919 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 179.056)",
    fill: "white"
  })), _rect920 || (_rect920 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 276.722)",
    fill: "white"
  })), _rect921 || (_rect921 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 227.889)",
    fill: "white"
  })), _rect922 || (_rect922 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 179.056)",
    fill: "white"
  })), _rect923 || (_rect923 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 276.722)",
    fill: "white"
  })), _rect924 || (_rect924 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 195.333)",
    fill: "white"
  })), _rect925 || (_rect925 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 195.333)",
    fill: "white"
  })), _rect926 || (_rect926 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 162.778)",
    fill: "white"
  })), _rect927 || (_rect927 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 227.889)",
    fill: "white"
  })), _rect928 || (_rect928 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 244.167)",
    fill: "white"
  })), _rect929 || (_rect929 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 244.167)",
    fill: "white"
  })), _rect930 || (_rect930 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 293)",
    fill: "white"
  })), _rect931 || (_rect931 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 309.278)",
    fill: "white"
  })), _rect932 || (_rect932 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 325.556)",
    fill: "white"
  })), _rect933 || (_rect933 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 341.833)",
    fill: "white"
  })), _rect934 || (_rect934 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 341.833)",
    fill: "white"
  })), _rect935 || (_rect935 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 358.111)",
    fill: "white"
  })), _rect936 || (_rect936 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 374.389)",
    fill: "white"
  })), _rect937 || (_rect937 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 293)",
    fill: "white"
  })), _rect938 || (_rect938 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 309.278)",
    fill: "white"
  })), _rect939 || (_rect939 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 325.556)",
    fill: "white"
  })), _rect940 || (_rect940 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 341.833)",
    fill: "white"
  })), _rect941 || (_rect941 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 341.833)",
    fill: "white"
  })), _rect942 || (_rect942 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 358.111)",
    fill: "white"
  })), _rect943 || (_rect943 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 374.389)",
    fill: "white"
  })), _rect944 || (_rect944 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 244.167)",
    fill: "white"
  })), _rect945 || (_rect945 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 195.333)",
    fill: "white"
  })), _rect946 || (_rect946 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 293)",
    fill: "white"
  })), _rect947 || (_rect947 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 309.278)",
    fill: "white"
  })), _rect948 || (_rect948 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 325.556)",
    fill: "white"
  })), _rect949 || (_rect949 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 341.833)",
    fill: "white"
  })), _rect950 || (_rect950 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 341.833)",
    fill: "white"
  })), _rect951 || (_rect951 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 358.111)",
    fill: "white"
  })), _rect952 || (_rect952 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 341.833)",
    fill: "white"
  })), _rect953 || (_rect953 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 341.833)",
    fill: "white"
  })), _rect954 || (_rect954 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 358.111)",
    fill: "white"
  })), _rect955 || (_rect955 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 358.111)",
    fill: "white"
  })), _rect956 || (_rect956 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 358.111)",
    fill: "white"
  })), _rect957 || (_rect957 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 325.556)",
    fill: "white"
  })), _rect958 || (_rect958 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 374.389)",
    fill: "white"
  })), _rect959 || (_rect959 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 374.389)",
    fill: "white"
  })), _rect960 || (_rect960 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 325.556)",
    fill: "white"
  })), _rect961 || (_rect961 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 309.278)",
    fill: "white"
  })), _rect962 || (_rect962 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 325.556)",
    fill: "white"
  })), _rect963 || (_rect963 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 341.833)",
    fill: "white"
  })), _rect964 || (_rect964 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 341.833)",
    fill: "white"
  })), _rect965 || (_rect965 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 358.111)",
    fill: "white"
  })), _rect966 || (_rect966 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 374.389)",
    fill: "white"
  })), _rect967 || (_rect967 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 244.167)",
    fill: "white"
  })), _rect968 || (_rect968 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 195.333)",
    fill: "white"
  })), _rect969 || (_rect969 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 293)",
    fill: "white"
  })), _rect970 || (_rect970 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 211.611)",
    fill: "white"
  })), _rect971 || (_rect971 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 244.167)",
    fill: "white"
  })), _rect972 || (_rect972 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 211.611)",
    fill: "white"
  })), _rect973 || (_rect973 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 211.611)",
    fill: "white"
  })), _rect974 || (_rect974 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 260.444)",
    fill: "white"
  })), _rect975 || (_rect975 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 260.444)",
    fill: "white"
  })), _rect976 || (_rect976 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 211.611)",
    fill: "white"
  })), _rect977 || (_rect977 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 162.778)",
    fill: "white"
  })), _rect978 || (_rect978 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 146.5)",
    fill: "white"
  })), _rect979 || (_rect979 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 260.444)",
    fill: "white"
  })), _rect980 || (_rect980 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 211.611)",
    fill: "white"
  })), _rect981 || (_rect981 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 162.778)",
    fill: "white"
  })), _rect982 || (_rect982 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 146.5)",
    fill: "white"
  })), _rect983 || (_rect983 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 260.444)",
    fill: "white"
  })), _rect984 || (_rect984 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 179.056)",
    fill: "white"
  })), _rect985 || (_rect985 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 179.056,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 179.056)",
    fill: "white"
  })), _rect986 || (_rect986 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 146.5)",
    fill: "white"
  })), _rect987 || (_rect987 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 146.5,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 146.5)",
    fill: "white"
  })), _rect988 || (_rect988 = /*#__PURE__*/React.createElement("rect", {
    x: 569.722,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 569.722 162.778)",
    fill: "white"
  })), _rect989 || (_rect989 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 130.222)",
    fill: "white"
  })), _rect990 || (_rect990 = /*#__PURE__*/React.createElement("rect", {
    x: 553.444,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 553.444 211.611)",
    fill: "white"
  })), _rect991 || (_rect991 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 195.333)",
    fill: "white"
  })), _rect992 || (_rect992 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 65.1111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 65.1111)",
    fill: "white"
  })), _rect993 || (_rect993 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 227.889)",
    fill: "white"
  })), _rect994 || (_rect994 = /*#__PURE__*/React.createElement("rect", {
    x: 195.333,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 195.333 195.333)",
    fill: "white"
  })), _rect995 || (_rect995 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 260.444)",
    fill: "white"
  })), _rect996 || (_rect996 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 276.722)",
    fill: "white"
  })), _rect997 || (_rect997 = /*#__PURE__*/React.createElement("rect", {
    x: 48.8335,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 48.8335 293)",
    fill: "white"
  })), _rect998 || (_rect998 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 244.167)",
    fill: "white"
  })), _rect999 || (_rect999 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 260.444)",
    fill: "white"
  })), _rect1000 || (_rect1000 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 276.722)",
    fill: "white"
  })), _rect1001 || (_rect1001 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 309.278)",
    fill: "white"
  })), _rect1002 || (_rect1002 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 309.278)",
    fill: "white"
  })), _rect1003 || (_rect1003 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 309.278)",
    fill: "white"
  })), _rect1004 || (_rect1004 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 293)",
    fill: "white"
  })), _rect1005 || (_rect1005 = /*#__PURE__*/React.createElement("rect", {
    x: 65.1113,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 65.1113 325.556)",
    fill: "white"
  })), _rect1006 || (_rect1006 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 325.556)",
    fill: "white"
  })), _rect1007 || (_rect1007 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 325.556)",
    fill: "white"
  })), _rect1008 || (_rect1008 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 341.833)",
    fill: "white"
  })), _rect1009 || (_rect1009 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 341.833)",
    fill: "white"
  })), _rect1010 || (_rect1010 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 358.111)",
    fill: "white"
  })), _rect1011 || (_rect1011 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 211.611)",
    fill: "white"
  })), _rect1012 || (_rect1012 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 227.889)",
    fill: "white"
  })), _rect1013 || (_rect1013 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 244.167)",
    fill: "white"
  })), _rect1014 || (_rect1014 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 260.444)",
    fill: "white"
  })), _rect1015 || (_rect1015 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 276.722)",
    fill: "white"
  })), _rect1016 || (_rect1016 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3887,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 81.3887 293)",
    fill: "white"
  })), _rect1017 || (_rect1017 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 195.333)",
    fill: "white"
  })), _rect1018 || (_rect1018 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 211.611)",
    fill: "white"
  })), _rect1019 || (_rect1019 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 227.889)",
    fill: "white"
  })), _rect1020 || (_rect1020 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 244.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 244.167)",
    fill: "white"
  })), _rect1021 || (_rect1021 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 260.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 260.444)",
    fill: "white"
  })), _rect1022 || (_rect1022 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 276.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 276.722)",
    fill: "white"
  })), _rect1023 || (_rect1023 = /*#__PURE__*/React.createElement("rect", {
    x: 97.6665,
    y: 293,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 97.6665 293)",
    fill: "white"
  })), _rect1024 || (_rect1024 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "white"
  })), _rect1025 || (_rect1025 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1026 || (_rect1026 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1027 || (_rect1027 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1028 || (_rect1028 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1029 || (_rect1029 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1030 || (_rect1030 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1031 || (_rect1031 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1032 || (_rect1032 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1033 || (_rect1033 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1034 || (_rect1034 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 325.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1035 || (_rect1035 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 309.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1036 || (_rect1036 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1037 || (_rect1037 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1038 || (_rect1038 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1039 || (_rect1039 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1040 || (_rect1040 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1041 || (_rect1041 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1042 || (_rect1042 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1043 || (_rect1043 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 618.556,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1044 || (_rect1044 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1045 || (_rect1045 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1046 || (_rect1046 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 455.778,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1047 || (_rect1047 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 423.222,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1048 || (_rect1048 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1049 || (_rect1049 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 439.5,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1050 || (_rect1050 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 406.944,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1051 || (_rect1051 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 390.667,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1052 || (_rect1052 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 374.389,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1053 || (_rect1053 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 358.111,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1054 || (_rect1054 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 341.833,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1055 || (_rect1055 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 553.444)",
    fill: "black"
  })), _rect1056 || (_rect1056 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 569.722)",
    fill: "black"
  })), _rect1057 || (_rect1057 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 586)",
    fill: "black"
  })), _rect1058 || (_rect1058 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 586)",
    fill: "black"
  })), _rect1059 || (_rect1059 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 586)",
    fill: "black"
  })), _rect1060 || (_rect1060 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 586)",
    fill: "black"
  })), _rect1061 || (_rect1061 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 586)",
    fill: "black"
  })), _rect1062 || (_rect1062 = /*#__PURE__*/React.createElement("rect", {
    x: 488.333,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 488.333 569.722)",
    fill: "black"
  })), _rect1063 || (_rect1063 = /*#__PURE__*/React.createElement("rect", {
    x: 504.611,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 504.611 569.722)",
    fill: "black"
  })), _rect1064 || (_rect1064 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 553.444)",
    fill: "black"
  })), _rect1065 || (_rect1065 = /*#__PURE__*/React.createElement("rect", {
    x: 520.889,
    y: 537.167,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 520.889 537.167)",
    fill: "black"
  })), _rect1066 || (_rect1066 = /*#__PURE__*/React.createElement("rect", {
    x: 537.167,
    y: 520.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 537.167 520.889)",
    fill: "black"
  })), _rect1067 || (_rect1067 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 602.278,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1068 || (_rect1068 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 586,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1069 || (_rect1069 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 569.722,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1070 || (_rect1070 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 553.444,
    width: 16.2778,
    height: 16.2778,
    fill: "black"
  })), _rect1071 || (_rect1071 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 195.333)",
    fill: "white"
  })), _rect1072 || (_rect1072 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 195.333)",
    fill: "white"
  })), _rect1073 || (_rect1073 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 162.778)",
    fill: "white"
  })), _rect1074 || (_rect1074 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 130.222)",
    fill: "white"
  })), _rect1075 || (_rect1075 = /*#__PURE__*/React.createElement("rect", {
    x: 358.111,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 358.111 211.611)",
    fill: "white"
  })), _rect1076 || (_rect1076 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 211.611)",
    fill: "white"
  })), _rect1077 || (_rect1077 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 195.333)",
    fill: "white"
  })), _rect1078 || (_rect1078 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 195.333)",
    fill: "white"
  })), _rect1079 || (_rect1079 = /*#__PURE__*/React.createElement("rect", {
    x: 455.778,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 455.778 211.611)",
    fill: "white"
  })), _rect1080 || (_rect1080 = /*#__PURE__*/React.createElement("rect", {
    x: 472.056,
    y: 227.889,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 472.056 227.889)",
    fill: "white"
  })), _rect1081 || (_rect1081 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 162.778)",
    fill: "white"
  })), _rect1082 || (_rect1082 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 130.222)",
    fill: "white"
  })), _rect1083 || (_rect1083 = /*#__PURE__*/React.createElement("rect", {
    x: 374.389,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 374.389 211.611)",
    fill: "white"
  })), _rect1084 || (_rect1084 = /*#__PURE__*/React.createElement("rect", {
    x: 439.5,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 439.5 211.611)",
    fill: "white"
  })), _rect1085 || (_rect1085 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 195.333)",
    fill: "white"
  })), _rect1086 || (_rect1086 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 195.333)",
    fill: "white"
  })), _rect1087 || (_rect1087 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 162.778)",
    fill: "white"
  })), _rect1088 || (_rect1088 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 130.222)",
    fill: "white"
  })), _rect1089 || (_rect1089 = /*#__PURE__*/React.createElement("rect", {
    x: 325.556,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 325.556 211.611)",
    fill: "white"
  })), _rect1090 || (_rect1090 = /*#__PURE__*/React.createElement("rect", {
    x: 390.667,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 390.667 211.611)",
    fill: "white"
  })), _rect1091 || (_rect1091 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 195.333)",
    fill: "white"
  })), _rect1092 || (_rect1092 = /*#__PURE__*/React.createElement("rect", {
    x: 423.222,
    y: 195.333,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 423.222 195.333)",
    fill: "white"
  })), _rect1093 || (_rect1093 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 162.778,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 162.778)",
    fill: "white"
  })), _rect1094 || (_rect1094 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 130.222,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 130.222)",
    fill: "white"
  })), _rect1095 || (_rect1095 = /*#__PURE__*/React.createElement("rect", {
    x: 341.833,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 341.833 211.611)",
    fill: "white"
  })), _rect1096 || (_rect1096 = /*#__PURE__*/React.createElement("rect", {
    x: 406.944,
    y: 211.611,
    width: 16.2778,
    height: 16.2778,
    transform: "rotate(90 406.944 211.611)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtPanda);
export default __webpack_public_path__ + "static/media/pixel-art-panda.872270fef0aafe3118b4cb0e5af16f33.svg";
export { ForwardRef as ReactComponent };